import { CIcon } from '~/icons/types'

export const ciStairs: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22 19H6.478v-2h2.479a1 1 0 0 0 1-1v-3h2.478a1 1 0 0 0 1-1V9h2.478a1 1 0 0 0 1-1V5H22a1 1 0 1 0 0-2h-5.652a1.47 1.47 0 0 0-1.435 1.5V7H12.87a1.47 1.47 0 0 0-1.435 1.5V11H9.391a1.47 1.47 0 0 0-1.434 1.5V15H5.913a1.47 1.47 0 0 0-1.435 1.5V19H2a1 1 0 0 0 0 2h20a1 1 0 0 0 0-2Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'stairs',
  type: 'regular'
}
